import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "popover-body" }
const _hoisted_2 = { style: {"margin-top":"10px"} }
const _hoisted_3 = { style: {"margin-top":"10px"} }
const _hoisted_4 = { style: {"margin-top":"10px"} }
const _hoisted_5 = { style: {"margin-top":"10px"} }
const _hoisted_6 = { style: {"margin-top":"10px"} }
const _hoisted_7 = { style: {"margin-top":"10px"} }

import { ref, onMounted, onUnmounted, nextTick, computed } from 'vue'
import { getOrderInfo } from '@/api/affairs'
import { useRouter, useRoute } from "vue-router";

export default /*@__PURE__*/_defineComponent({
  __name: 'orderMseeage',
  setup(__props) {

const route = useRoute()
const visible = ref(false)
const tagRef = ref<HTMLElement | null>(null)
const popoverStyle = ref<Record<string, string>>({})
const popoverRef = ref<HTMLElement | null>(null)


const pageshow = computed(() => {
    const urlParams = new URLSearchParams(window.location.search)
    const order_no = urlParams.get('order_no')
    return order_no
})



let orderinfo = ref<any>({})
const computePosition = () => {
    const el = tagRef.value
    if (!el) return
    const rect = el.getBoundingClientRect()
    const left = rect.right + 12
    const popH = popoverRef.value ? popoverRef.value.offsetHeight : 0
    const top = rect.top + (rect.height - popH) / 2
    popoverStyle.value = {
        position: 'fixed',
        left: `${left}px`,
        top: `${top}px`,
        width: '220px',
        zIndex: '1000'
    }
}

const toggle = async () => {
    visible.value = !visible.value
    if (visible.value) {
        await nextTick()
        computePosition()
    }
}

onMounted(async () => {
    await nextTick()
    computePosition()
    window.addEventListener('resize', computePosition)
    const urlParams = new URLSearchParams(window.location.search)
    const order_no = urlParams.get('order_no')
    if (order_no) {
        visible.value = true
        await nextTick()
        computePosition()
        getOrderInfo({ order_no }).then(async res => {
            if (res.data.code == 200) {
                orderinfo.value = res.data.data
                orderinfo.value.order_no = order_no
                await nextTick()
                computePosition()
            }
        })
    }
})

onUnmounted(() => {
    window.removeEventListener('resize', computePosition)
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (pageshow.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          ref_key: "tagRef",
          ref: tagRef,
          class: "tags",
          onClick: toggle
        }, [...(_cache[0] || (_cache[0] = [
          _createTextVNode("订单 ", -1),
          _createElementVNode("br", null, null, -1),
          _createTextVNode(" 信息", -1)
        ]))], 512))
      : _createCommentVNode("", true),
    _withDirectives(_createElementVNode("div", {
      ref_key: "popoverRef",
      ref: popoverRef,
      class: "custom-popover",
      style: _normalizeStyle(popoverStyle.value)
    }, [
      _cache[8] || (_cache[8] = _createElementVNode("div", { class: "popover-arrow" }, null, -1)),
      _createElementVNode("div", _hoisted_1, [
        _cache[7] || (_cache[7] = _createElementVNode("div", { class: "h-36px flex justify-between items-center" }, [
          _createElementVNode("span", { class: "header-title" }, "订单信息 ")
        ], -1)),
        _createElementVNode("ul", null, [
          _createElementVNode("div", _hoisted_2, [
            _cache[1] || (_cache[1] = _createElementVNode("strong", null, " 做图状态：", -1)),
            _createElementVNode("span", {
              style: _normalizeStyle({ color: _unref(route).query.now_state !== '待做图' ? 'green' : '' })
            }, _toDisplayString(_unref(route).query.now_state), 5)
          ]),
          _createElementVNode("div", _hoisted_3, [
            _cache[2] || (_cache[2] = _createElementVNode("strong", null, " 订单编号：", -1)),
            _createTextVNode(_toDisplayString(_unref(orderinfo).order_no), 1)
          ]),
          _createElementVNode("div", _hoisted_4, [
            _cache[3] || (_cache[3] = _createElementVNode("strong", null, " 定制信息：", -1)),
            _createTextVNode(_toDisplayString(_unref(orderinfo).staff_node), 1)
          ]),
          _createElementVNode("div", _hoisted_5, [
            _cache[4] || (_cache[4] = _createElementVNode("strong", null, " 买家留言：", -1)),
            _createTextVNode(_toDisplayString(_unref(orderinfo).buyer_msg), 1)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _cache[5] || (_cache[5] = _createElementVNode("strong", null, " 打印备注：", -1)),
            _createTextVNode(_toDisplayString(_unref(orderinfo).print_remark), 1)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _cache[6] || (_cache[6] = _createElementVNode("strong", null, " 后台备注：", -1)),
            _createTextVNode(_toDisplayString(_unref(orderinfo).notes), 1)
          ])
        ])
      ])
    ], 4), [
      [_vShow, visible.value]
    ])
  ]))
}
}

})